<wil-wheel [wheelId]="'home'" type="noAuth" data-testid="guest-home-wheel"></wil-wheel>

<hr />

<wil-professional-plan-feature-promotion data-testid="guest-home-professional-promotion"></wil-professional-plan-feature-promotion>

<wil-donate data-testid="guest-home-donate"></wil-donate>
